<div class="ct-dialog ct-dialog-add ct-project-dialog">
  <div class="ct-dialog-title">
    <span>{{ dialogHeader }}</span>
    <span *ngIf="setting.id">{{ setting.settingName }}</span>
    <button class="ct-dialog-close" mat-dialog-close ctClickClose></button>
  </div>

  <form #jiraForm="ngForm" class="ct-form-add" autocomplete="off">
    <div class="ct-form-block">
      <!-- Email -->
      <div>
        <label class="ct-form-label">Email</label>
        <div class="ct-required-field-container">
          <input class="ct-input ct-full-width" name="email" #email="ngModel"
                 [(ngModel)]="model.userEmail"
                 (ngModelChange)="showErrors[1] = false"
                 required email/>
        </div>
        <div *ngIf="showErrors[1] && email.errors?.required" class="ct-error-text">
          Email is required!
        </div>
        <div *ngIf="showErrors[1] && email.errors?.email" class="ct-error-text">
          Email is invalid!
        </div>
      </div>

      <!-- Token -->
      <div>
        <label class="ct-form-label">Token</label>
        <div class="ct-required-field-container">
          <input class="ct-input ct-full-width" name="token" #token="ngModel"
                 [(ngModel)]="model.apiToken"
                 (ngModelChange)="showErrors[3] = false"
                 required/>
        </div>
        <div *ngIf="showErrors[3] && !model.apiToken" class="ct-error-text">
          Token is required!
        </div>
      </div>
    </div>

    <div class="ct-buttons-block" mat-dialog-actions>
      <button type="button" mat-raised-button class="ct-button ct-blue-button"
              [class.ct-loading]="isValidateLoading"
              [disabled]="isValidateLoading || isRequestLoading"
              (click)="validateAndSubmit(jiraForm)">
        {{ submitButtonText }}
      </button>
      <button mat-dialog-close class="ct-cancel-button">Cancel</button>
    </div>
  </form>
</div>
